import { Space, Tag, Spin } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import TableWithSorter from '../../Common/TableWithSorter';
import { getSubunitKind, exerciseTypesMapReverse } from '../SubunitHelpers';

const SubnitTable = (props) => {
  const {
    data,
    current,
    totalCount,
    onPaginationChange,
    currentParams,
    setFilteredParams,
    offset,
    fetching,
  } = props;
  // const [filteredKind, setFilteredKinds] = useState({});
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      sorter: (a, b) => a.code.localeCompare(b.code),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/subunit/' + record.code}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Kind',
      render: (value, record) => (
        <span>
          {record ? getSubunitKind(record) : 'undefined-subunit-kind'}
        </span>
      ),
      filters: [
        {
          text: 'Filter Exercises',
          value: 'Exercise',
        },
        {
          text: 'Filter Videos',
          value: 'Video',
        },
        {
          text: 'Filter Assignments',
          value: 'Assignment',
        },
        {
          text: 'Filter Certificates',
          value: 'Certificate',
        },
      ],
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value, record) => exerciseTypesMapReverse[value] in record,
    },
  ];

  return (
    <div>
      {fetching ? <Spin /> : null}
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <TableWithSorter
            loading={fetching}
            tableLayout="auto"
            scroll={{ x: 1000 }}
            expandable={{ defaultExpandAllRows: true }}
            columns={columns}
            dataSource={data}
            pagination={{
              current: current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 && !fetching ? <div>No record found</div> : null}
    </div>
  );
};

export default SubnitTable;
